import { useLayoutEffect, useState } from "react";
import { useAppContext } from "../../../contexts/app";
import { Field, Label } from "../../../components/forms";
import { UseGoogleSheet } from "../../../hooks/UseGoogleSheets";
import { FieldsetWrapperFS } from "../unit/page";
import { convertGoogleDate } from "./pdf";
import { ButtonLight } from "../../../components/ctas";


export const convertGogoleDate = (dateString) => {
	const date = new Date(dateString);
	const options = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		hour12: true,
	};
	const formattedDate = date.toLocaleString('en-US', options);
	return formattedDate.replace(',', '');
};

export const convertToMoney2 = (value1) => {
	const value = Number(value1)
	if (typeof value === 'number') {
		return value.toLocaleString('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
	} else if (typeof value === 'string') {
		const numberValue = parseFloat(value.replace(/[^0-9.-]+/g, ''));
		if (!isNaN(numberValue)) {
			return numberValue.toLocaleString('en-US', {
				style: 'currency',
				currency: 'USD',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
		} else {
			return value;
		}
	} else {
		return value;
	}
}



const CustomerItem = ({ uuid, customerName, date, businessName, updatedBy, targetedDeliveryDate,  shippingCosts, updatedOn, createdOn, createdBy, alpha, alphaAPEX, alphaSIGHT, alphaFLIGHT, bravo, pogo }) => {
	const units = [alpha, alphaAPEX, alphaSIGHT, alphaFLIGHT, bravo, pogo];
	const addUnits = units.reduce((acc, item) => {
		const unit = Number(item) || 0;
		if (typeof unit === 'number') {
			return acc + unit;
		} else if (typeof unit === 'string' && !isNaN(unit)) {
			return acc + parseInt(unit, 10);
		}
		return acc;
	}, 0);

	useLayoutEffect(() => {
		console.log(units, addUnits)
	}, []);



	return <>
		<span className="tw-border tw-border-white  tw-my-20px tw-p-10px tw-relative tw-block tw-w-full">
			<h1 className="tw-font-bold">{ businessName } - # of Units: { addUnits } </h1>
			<span className="tw-block tw-w-full tw-py-5px">
				Customer Name: { customerName }
			</span>
			<span className="tw-block tw-w-full tw-py-5px">
				Targeted Delivery Date: { targetedDeliveryDate }
			</span>
			<span className="tw-block tw-w-full tw-pt-5px tw-pb-10px">
				{ shippingCosts === "TBD" ? <b className="tw-font-bold tw-uppercase">Need to estimate Shipping Costs</b> : `Estimated Shipping Costs: ${convertToMoney2(shippingCosts)}`}
			</span>
			<ul className="tw-grid tw-grid-cols-2 tw-gap-10px">
				<li>
					Updated By: { updatedBy ||  createdBy }
				</li>
				<li>
					Updated On: { convertGogoleDate(updatedOn || createdOn) }
				</li>
				<li>
					Created By: { createdBy }
				</li>
				<li>
					Created On: { convertGogoleDate(createdOn) }
				</li>
			</ul>
			<div className="tw-flex tw-justify-between tw-items-center tw-border-t-1px tw-py-10px tw-mt-10px">
				<a href={`/fs/quote/${uuid}`} className="tw-text-white tw-text-lg tw-font-bold tw-underline">
					<span className="tw-pointer-events-none">
						View/edit
					</span>
				</a>
				<ButtonLight href={`/fs/quote/pdf/${uuid}`} default target="_blank">
					<span className="tw-pointer-events-none tw-py-5px tw-flex tw-items-center tw-justify-center tw-w-full">
						<span>
							Generate Quote
						</span>
					</span>
				</ButtonLight>
			</div>
		</span>
	</>
}

export default function Quotes() {

	const appContext = useAppContext();
	const [customerRows, setCustomerRows] = useState([]);
	const [unitSearch, setUnitSearch] = useState("");

	//Customers google sheet
	const { loadSheet: loadCustomerSheet } = UseGoogleSheet({ spreadsheetId: process.env.REACT_APP_FS_QUOTES });

	useLayoutEffect(() => {
		loadCustomerSheet(true).then((sheets) => {
			setCustomerRows(sheets);
		});
	}, []);

	// Filter rows based on the search input
	const filteredCustomerRows = customerRows.filter((row) => {
		const customerName = row.get("Business Name");
		return customerName && customerName.toLowerCase().includes(unitSearch.toLowerCase());
	});


	return <>
		<div className="tw-w-full">
			{ appContext.rows &&
				<div>
				 {/* Search Input Field */}
				 <FieldsetWrapperFS title="Search Quotes" className="tw-mb-5">
					<Field
					type="text"
					placeholder="Search by business name"
					value={unitSearch}
					onChange={(e) => setUnitSearch(e.target.value)} // Update search state
					/>
					<Label>Search</Label>
				</FieldsetWrapperFS>
					<br />
					{filteredCustomerRows.map((row) => {
						const customerName = row.get("Customer Name");
						const date = row.get("Updated On") || row.get("Created On");
						const uuid = row.get("UUID");

						return (
						uuid && (
							<CustomerItem
								key={uuid}
								uuid={uuid}
								businessName={row.get("Business Name")}
								updatedBy={row.get("Updated By" || row.get("Created By") || "--" )}
								updatedOn={row.get("Updated On") || row.get("Created On") || "--" }
								createdOn={row.get("Created On") || "--"}
								createdBy={row.get("Created By") || "--"}
								targetedDeliveryDate={row.get("Targeted Delivery Date") || "TBD"}
								shippingCosts={row.get("Shipping Costs") || "TBD"}
								alpha={ row.get("Alpha" || 0)}
								alphaSIGHT={ row.get("Alpha SIGHT" || 0)}
								alphaAPEX={ row.get("Alpha APEX" || 0)}
								alphaFLIGHT={ row.get("Alpha FLIGHT" || 0)}
								bravo={ row.get("Bravo" || 0)}
								pogo={ row.get("Pogo" || 0)}
								date={ convertGoogleDate(date) }
								customerName={customerName || "--"}
							/>
						)
						);
					})}

				</div>
			}
		</div>
	</>
}
